import { createContext, useContext, type ReactNode } from 'react'
import type { TFunction } from 'i18next'

/**
 * Функция перевода через контекст.
 *
 * Отдельного пакета вроде react-i18next не заводим: нужен ровно один
 * `t`, а лишняя зависимость в клиенте — лишний повод обновляться.
 * Инициализацию делает точка входа, тесты подставляют свой `t`.
 */

const I18nContext = createContext<TFunction | null>(null)

export function I18nProvider({
  t,
  children,
}: {
  readonly t: TFunction
  readonly children: ReactNode
}) {
  return <I18nContext.Provider value={t}>{children}</I18nContext.Provider>
}

export function useT(): TFunction {
  const t = useContext(I18nContext)
  if (t === null) {
    // Строка без словаря — это строка, зашитая в компонент (D11).
    throw new Error('I18nProvider не найден: перевод недоступен')
  }
  return t
}
